import React from 'react';
import { getAgeRatingColor } from '@jwp/ott-common/src/utils/ageRating';

import styles from './AgeRatingBadge.module.scss';

type Props = {
  label: string;
  className?: string;
};

const AgeRatingBadge = ({ label, className }: Props) => {
  const color = getAgeRatingColor(label);

  return (
    <span
      className={className ? `${styles.badge} ${className}` : styles.badge}
      style={{ '--age-rating-color': color } as React.CSSProperties}
      aria-label={label}
    >
      {label}
    </span>
  );
};

export default AgeRatingBadge;
